import { createContext, RefObject } from 'react';

// Allow routes to put something in the top bar
export const TopBarContentContext = createContext<RefObject<HTMLElement> | void>(undefined);
